import React, { useState } from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

const INITIAL_BOOKMARKS = [
  { id: 1, name: "NYC Q1 2025 Analysis", filters: "Single Family · 12mo · All segments", savedAt: "Mar 1, 2025" },
  { id: 2, name: "Brooklyn Luxury Trends", filters: "Condo · 24mo · Luxury >$1.5M", savedAt: "Feb 22, 2025" },
  { id: 3, name: "Entry Market Watch", filters: "All Types · 6mo · <$300K", savedAt: "Feb 15, 2025" },
];

export default function BookmarkPanel() {
  const [bookmarks, setBookmarks] = useState(INITIAL_BOOKMARKS);
  const [open, setOpen] = useState(false);
  const [newName, setNewName] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSave = () => {
    if (!newName?.trim()) return;
    setSaving(true);
    setTimeout(() => {
      setBookmarks(prev => [
        { id: Date.now(), name: newName?.trim(), filters: "Current filters applied", savedAt: "Mar 3, 2025" },
        ...prev,
      ]);
      setNewName("");
      setSaving(false);
    }, 600);
  };

  const handleDelete = (id) => {
    setBookmarks(prev => prev?.filter(b => b?.id !== id));
  };

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(p => !p)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg border border-border bg-background
                   hover:bg-muted transition-standard text-sm font-caption font-medium text-foreground
                   focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        aria-label="Saved analysis bookmarks"
        aria-expanded={open}
      >
        <Icon name="Bookmark" size={14} color="currentColor" />
        <span className="hidden sm:inline">Saved</span>
        {bookmarks?.length > 0 && (
          <span className="filter-badge">{bookmarks?.length}</span>
        )}
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-[1998]" onClick={() => setOpen(false)} aria-hidden="true" />
          <div
            className="absolute right-0 top-full mt-2 w-72 bg-card border border-border rounded-xl z-[1999] overflow-hidden"
            style={{ boxShadow: "var(--shadow-xl)" }}
          >
            <div className="px-4 py-3 border-b border-border flex items-center justify-between">
              <h4 className="font-heading font-semibold text-sm text-foreground">Saved Analyses</h4>
              <button onClick={() => setOpen(false)} className="text-muted-foreground hover:text-foreground transition-standard">
                <Icon name="X" size={14} color="currentColor" />
              </button>
            </div>

            <div className="p-3 border-b border-border">
              <div className="flex gap-2">
                <input
                  type="text"
                  value={newName}
                  onChange={e => setNewName(e?.target?.value)}
                  placeholder="Name this analysis..."
                  className="flex-1 h-8 px-2.5 text-xs font-caption bg-background border border-border rounded-lg
                             text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring"
                  onKeyDown={e => e?.key === "Enter" && handleSave()}
                />
                <Button variant="default" size="xs" loading={saving} onClick={handleSave} disabled={!newName?.trim()}>
                  Save
                </Button>
              </div>
            </div>

            <div className="max-h-56 overflow-y-auto">
              {bookmarks?.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-8 text-center">
                  <Icon name="BookmarkX" size={24} color="var(--color-muted-foreground)" />
                  <p className="text-xs font-caption text-muted-foreground mt-2">No saved analyses yet</p>
                </div>
              ) : (
                bookmarks?.map(b => (
                  <div key={b?.id} className="flex items-start gap-2 px-4 py-3 border-b border-border/50 hover:bg-muted/40 transition-standard group">
                    <Icon name="BookmarkCheck" size={14} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
                    <div className="flex-1 min-w-0">
                      <p className="text-xs font-caption font-semibold text-foreground truncate">{b?.name}</p>
                      <p className="text-xs font-caption text-muted-foreground truncate">{b?.filters}</p>
                      <p className="text-xs font-caption text-muted-foreground/60">{b?.savedAt}</p>
                    </div>
                    <button
                      onClick={() => handleDelete(b?.id)}
                      className="opacity-0 group-hover:opacity-100 transition-standard text-muted-foreground hover:text-accent"
                      aria-label={`Delete bookmark ${b?.name}`}
                    >
                      <Icon name="Trash2" size={12} color="currentColor" />
                    </button>
                  </div>
                ))
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}